import { template } from 'lodash';
import axios from './client';

const SETTING = '/setting';
const SETTING_ID = template('/setting/<%= id %>');
const AGREEMENT_DATE = 'ServiceAgreementDate';
const FLYER_TEMPLATE = 'MarketingMaterials';
const LEAD_SOURCE_LAST_UPDATE = 'LeadSource';
const LEAD_FIRST_TOUCH_LAST_UPDATE = 'LeadFirstTouch';
const LEAD_DISTRIBUTION_LAST_UPDATE = 'LeadDistribution';
const CONFIRM = '/confirmProviderAgreement';
const NEWS_UPDATES = '/manage/news-updates';
const NEWS_UPDATES_RESOURCES = '/manage/news-updates/resources';

export function getLeadFirstTouch(show) {
  if (show) {
    return axios.get(`${SETTING}/lead-first-touch?show=${show}`);
  }
  return axios.get(`${SETTING}/lead-first-touch`);
}

export function getLeadSources(distributed) {
  return axios.get(`${SETTING}/lead-sources?distributed=${distributed}`);
}

export function getLeadDistribution() {
  return axios.get(`${SETTING}/lead-distribution`);
}
export function getLeadDistributionUpdateSetting() {
  return axios.get(`${SETTING}?name=${LEAD_DISTRIBUTION_LAST_UPDATE}`);
}

export function getLeadFirstTouchLastUpdate() {
  return axios.get(`${SETTING}?name=${LEAD_FIRST_TOUCH_LAST_UPDATE}`);
}

export function getLeadSourcesUpdateSetting() {
  return axios.get(`${SETTING}?name=${LEAD_SOURCE_LAST_UPDATE}`);
}

export function postLeadFirstTouch(payload) {
  return axios.post(`${SETTING}/lead-first-touch`, payload);
}

export function postLeadSources(payload) {
  return axios.post(`${SETTING}/lead-sources`, payload);
}

export function postLeadDistribution(payload) {
  return axios.post(`${SETTING}/lead-distribution`, payload);
}

export function postLeadDistributionOwners(payload) {
  const { id } = payload;
  const { leadOwners } = payload;
  return axios.post(`${SETTING}/lead-distribution/${id}/lead-owners`, leadOwners);
}

export function assignLeadSourcesToSets(payload) {
  return axios.post(`${SETTING}/assign-lead-sources-to-sets`, payload);
}

export function removeLeadDistribution(id) {
  return axios.delete(`${SETTING}/lead-distribution/${id}`);
}

export function getAgreementDateSetting() {
  return axios.get(`${SETTING}?name=${AGREEMENT_DATE}`);
}

export function getFlyerTemplateSetting() {
  return axios.get(`${SETTING}?name=${FLYER_TEMPLATE}`);
}

/**
 * set Agreement date
 * @returns {Promise<any>}
 */
export function setAgreementDate(id) {
  return axios.post(SETTING_ID({ id }));
}

/**
 * update Flyer template setting
 */
export function updateFlyerTemplateSetting(payload) {
  const id = payload instanceof FormData ? payload.get('id') : payload.id;
  const headers = { 'Content-Type': 'multipart/form-data' };
  return axios.post(SETTING_ID({ id }), payload, { headers, timeout: 0 });
}


/**
 * set date
 * @returns {Promise<any>}
 */
export function setConfirm() {
  return axios.post(CONFIRM);
}

export function getMultipleUsers() {
  return axios.get(`${SETTING}/multiple-users`);
}

export function setMultipleUsers(payload) {
  return axios.post(`${SETTING}/multiple-users`, payload);
}

export function getContractorTeamAllowedResources() {
  return axios.get(NEWS_UPDATES_RESOURCES);
}

export function getNewsAndUpdates(params) {
  return axios.get(NEWS_UPDATES, { params });
}
export function postNewsAndUpdates(payload) {
  return axios.post(NEWS_UPDATES, payload);
}
